import { navigate } from 'gatsby'
import React from 'react'

import { IContentfulLeadForm } from '../../logic/shared-types'
import { isExternal } from '../../logic/url'
import Button from '../Button'
import { SubscriptionForm } from '../SubscriptionForm'

export const LeadForm = ({
  section,
  pageSlug,
}: {
  section: IContentfulLeadForm
  pageSlug: string
}) => {
  const { title, actionTitle, actionLink } = section

  if (actionLink) {
    return (
      <div className="flex flex-col items-start justify-between gap-4 rounded-lg border border-gray-300 px-4 py-4 sm:flex-row sm:items-center">
        <h3 className="font-primary text-sm sm:text-base">{title}</h3>
        <Button
          size="base"
          className="min-w-auto"
          onClick={() => {
            if (isExternal(actionLink)) {
              window.open(actionLink, '_blank', 'noopener,noreferrer')
              return
            }
            void navigate(actionLink)
          }}
        >
          {actionTitle}
        </Button>
      </div>
    )
  }

  return (
    <div className="rounded-lg border border-gray-300 p-6">
      <SubscriptionForm
        sectionId={section.contentful_id}
        pageSlug={pageSlug}
        {...section}
      />
    </div>
  )
}
